var _circle, _circle2, _g, _circle3, _g2, _circle4, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#F7CC7F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_11782",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 400
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_11782)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309 35C309 28.3726 303.627 23 297 23H40C33.3726 23 28 28.3726 28 35C28 41.6274 33.3726 47 40 47H160C166.627 47 172 52.3726 172 59C172 65.6274 166.627 71 160 71H156C149.373 71 144 76.3726 144 83C144 89.6274 149.373 95 156 95H232C238.627 95 244 89.6274 244 83C244 76.3726 238.627 71 232 71H229L228.999 70.9897C222.604 70.727 217.5 65.4595 217.5 59C217.5 52.5405 222.604 47.273 228.999 47.0103L229 47H297C303.627 47 309 41.6274 309 35ZM290 131C290 124.373 284.627 119 278 119H216C209.373 119 204 124.373 204 131C204 137.627 209.373 143 216 143H278C284.627 143 290 137.627 290 131ZM-9.5 167C-2.87258 167 2.5 172.373 2.5 179C2.5 185.627 -2.87258 191 -9.5 191H-53.5C-60.1274 191 -65.5 185.627 -65.5 179C-65.5 172.373 -60.1274 167 -53.5 167H-9.5ZM302 179C302 172.373 296.627 167 290 167H59C52.3726 167 47 172.373 47 179C47 185.627 52.3726 191 59 191H129C135.627 191 141 196.373 141 203C141 209.627 135.627 215 129 215H120C113.373 215 108 220.373 108 227C108 233.627 113.373 239 120 239H262C268.627 239 274 244.373 274 251C274 257.627 268.627 263 262 263H256C249.373 263 244 268.373 244 275C244 281.627 249.373 287 256 287H332C338.627 287 344 281.627 344 275C344 268.373 338.627 263 332 263H331L330.999 262.99C324.604 262.727 319.5 257.46 319.5 251C319.5 244.54 324.604 239.273 330.999 239.01L331 239H351C357.627 239 363 233.627 363 227C363 220.373 357.627 215 351 215H271V214.99C264.605 214.727 259.5 209.46 259.5 203C259.5 196.54 264.605 191.273 271 191.01V191H290C296.627 191 302 185.627 302 179ZM322 323C322 316.373 316.627 311 310 311H79C72.3726 311 67 316.373 67 323C67 329.627 72.3726 335 79 335H120C126.627 335 132 340.373 132 347C132 353.627 126.627 359 120 359H116C109.373 359 104 364.373 104 371C104 377.627 109.373 383 116 383H192C198.627 383 204 377.627 204 371C204 364.373 198.627 359 192 359H189L188.999 358.99C182.604 358.727 177.5 353.46 177.5 347C177.5 340.54 182.604 335.273 188.999 335.01L189 335H310C316.627 335 322 329.627 322 323ZM117 263C123.627 263 129 268.373 129 275C129 281.627 123.627 287 117 287H41C34.3726 287 29 281.627 29 275C29 268.373 34.3726 263 41 263H117ZM455 227C455 220.373 449.627 215 443 215H402C395.373 215 390 220.373 390 227C390 233.627 395.373 239 402 239H443C449.627 239 455 233.627 455 227ZM139 119C145.627 119 151 124.373 151 131C151 137.627 145.627 143 139 143H119C112.373 143 107 137.627 107 131C107 124.373 112.373 119 119 119H139ZM300 71C306.627 71 312 76.3726 312 83C312 89.6274 306.627 95 300 95H280C273.373 95 268 89.6274 268 83C268 76.3726 273.373 71 280 71H300ZM120 83C120 76.3726 114.627 71 108 71H88C81.3726 71 76 76.3726 76 83C76 89.6274 81.3726 95 88 95H108C114.627 95 120 89.6274 120 83Z",
    fill: "#FFE6AE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_11782",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 400
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_11782)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87 191C93.6274 191 99 196.373 99 203C99 209.627 93.6274 215 87 215H83C76.3726 215 71 220.373 71 227C71 233.627 76.3726 239 83 239H159C165.627 239 171 233.627 171 227C171 220.373 165.627 215 159 215H156L155.999 214.99C149.604 214.727 144.5 209.46 144.5 203C144.5 196.54 149.604 191.273 155.999 191.01L156 191H224C230.627 191 236 185.627 236 179C236 172.373 230.627 167 224 167H64L64.0004 166.99C57.6047 166.728 52.5 161.46 52.5 155C52.5 148.54 57.6047 143.272 64.0004 143.01L64 143H142C148.627 143 154 137.627 154 131C154 124.373 148.627 119 142 119H-14C-20.6274 119 -26 124.373 -26 131C-26 137.627 -20.6274 143 -14 143H16C22.6274 143 28 148.373 28 155C28 161.627 22.6274 167 16 167H2C-4.62742 167 -10 172.373 -10 179C-10 185.627 -4.62742 191 2 191H87ZM217 275C217 268.373 211.627 263 205 263H143C136.373 263 131 268.373 131 275C131 281.627 136.373 287 143 287H205C211.627 287 217 281.627 217 275ZM227 215C233.627 215 239 220.373 239 227C239 233.627 233.627 239 227 239H207C200.373 239 195 233.627 195 227C195 220.373 200.373 215 207 215H227ZM415 227C415 220.373 409.627 215 403 215H302C295.373 215 290 220.373 290 227C290 233.627 295.373 239 302 239H403C409.627 239 415 233.627 415 227ZM35 215C41.6274 215 47 220.373 47 227C47 233.627 41.6274 239 35 239H15C8.37258 239 3 233.627 3 227C3 220.373 8.37258 215 15 215H35ZM360 179C360 172.373 354.627 167 348 167H328C321.373 167 316 172.373 316 179C316 185.627 321.373 191 328 191H348C354.627 191 360 185.627 360 179Z",
    fill: "#E29F58"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_11782",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 400
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_11782)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.0775757,
    x: 201,
    y: -25,
    width: 225,
    height: 450,
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenus);
export default __webpack_public_path__ + "static/media/Venus.fbb6ba251fe29b795421626e9b78a79e.svg";
export { ForwardRef as ReactComponent };